<template>
  <div class="map-delivery home-page-map-custom">

    <div class="header">
      <i aria-hidden="true" class="fa fa-angle-left">

      </i>
      <a @click="$emit('close')" class="back-button text-black cursor-pointer decoration-none" style="    text-align: center;
    width: 100%;">

        <div class="text-span">{{$t('quession_map_delivery')}}</div>

      </a>
    </div>

    <input type="text" :value="address_modal" class="search search--hut input xs-border-none xs-py-10 xs-px-10 address-modal-map-delivery">

    <div id="map_delivery_mobile"  class="map_delivery_mobile-home-page"></div>

    <div class="footer">
      <span>{{$t('content')}}</span>
      <button type="button" @click="clickContinue" class="button button--primary typography-4">
        <span>
          <font style="vertical-align: inherit;">
          <font style="vertical-align: inherit;">{{$t('confirm')}}</font></font>
        </span>
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['lat','lng','address'],
    name: "ModalMapDelivery",
    data() {
      return {
        address_default: this.address,
        address_modal : '',
        lat_modal: '',
        lng_modal: ''
      }
    },
    mounted() {
      this.lat_modal = this.lat
      this.lng_modal = this.lng
      this.checkData()
    },
    methods: {
      clickContinue() {
        let vm = this
        this.$root.$emit('search', {address:vm.address_modal, lat:vm.lat_modal, lng: vm.lng_modal})
        vm.$emit('close')
      },
      checkData () {
        if(this.address_default=='') {
          this.getAddress(this.lat, this.lng)
        }else{
          this.address_modal = this.address_default
          this.showMap()
        }
      },
      showMap() {
        let vm = this
        var location = {lat:vm.lat,lng:vm.lng}
        var map = new google.maps.Map(
          document.getElementById('map_delivery_mobile'), {
            zoom: 15,
            center: location,
            streetViewControl: false,
            fullscreenControl: false,
            mapTypeControl: false,
            scaleControl:false,
          });

        var marker = new google.maps.Marker({
          position: location,
          map: map,
          draggable: true,
          animation: google.maps.Animation.DROP,
        });
        marker.addListener('drag', (event) => {
          vm.getAddress(event.latLng.lat(),event.latLng.lng())
        });
      },
      getAddress (lat, lng) {
        let vm = this
        vm.lat_modal = lat
        vm.lng_modal = lng
        var geocoder = new google.maps.Geocoder;
        let latlng = {lat: lat, lng: lng}
        geocoder.geocode({'location': latlng}, function(results, status) {
          if (status === 'OK') {
            if (results && results[0]) {
              vm.address_modal = results[0].formatted_address
              if(vm.address_default =='') {
                vm.showMap()
                vm.address_default = vm.address_modal
              }
            }
          }
        });
      },
    }
  }
</script>

<style scoped>
  #map_delivery_mobile {
    height: 100%;
    width: 100%;
    position: fixed !important;
  }
  button.close {
    position: fixed !important;

  }
  .text-span {
    font-size: 20px;
    font-family: Open Sans, sans-serif;
  }
  .map-delivery button.close {
    background: #0000009c !important;
  }
  @media screen and (max-width: 800px){
    .map-delivery {
      height: 100%;
      width: 100%;
      position: fixed;
      z-index: 999999999;
    }
  }
  button.close span {
    text-align: center;
    width: 100%;
    font-size: 23px;
    font-weight: 500;

  }
  .address-modal-map-delivery {
    position: fixed;
    z-index: 9999;
    top: 65px;
  }
  .header {
    height: 50px;
    margin-bottom: 0%;
    background: #fff;
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    z-index: 99999;

  }
  .header i {
    position: fixed;
    top: 10px;
    left: 15px;
    font-size: 30px;
  }
  .header .back-button {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 30px;
  }
  .footer {
    width: 100%;
    position: fixed;
    bottom: 0;
    background: #fff;
    padding: 3%;
    text-align: center;
  }
  .button {
    margin-top: 2%;
  }
</style>



// WEBPACK FOOTER //
// src/components/popup/ModalMapDelivery.vue